const predicates = [
  [movieIsAvailable, getMovieDescription],
  [isAvailable_ONLY_onSubscription, getSubscriptionPromo],
  [isAvailable_NOT_ONLY_onSubscription, getGeneralPromo],
  [() => true, getMovieDescription],
];

export default function resolveDescriptionContent(props) {
  const [, getContent] = predicates.find(([test]) => test(props));
  return getContent(props);
}

function movieIsAvailable({ isAvailable }) {
  return isAvailable;
}

function isAvailable_ONLY_onSubscription({ isAvailable, hasSVOD, hasTVOD, hasDTO }) {
  return !isAvailable && [!hasTVOD, !hasDTO, hasSVOD].every(Boolean);
}

function isAvailable_NOT_ONLY_onSubscription({ isAvailable, hasSVOD, hasTVOD, hasDTO }) {
  return !isAvailable && [hasTVOD, hasDTO, hasSVOD].some(Boolean);
}

function getMovieDescription({ movie }) {
  return movie.description;
}

function getSubscriptionPromo({ subscriptionInfo }) {
  return subscriptionInfo.promo;
}

function getGeneralPromo({ translate }) {
  return translate('embed.svod_tvod_description');
}
